<template>
    <div class="modal-container"
         data-balloon="click for datasheet"
         data-balloon-pos="up">
        <input type="checkbox" @click="selectProduct" :checked="isSelected" :id="result.objectID">
        <label class="checkbox" :for="result.objectID">
            <a href="#"
               @click.prevent
               @click="open"
               v-text="result.title">
            </a>
        </label>
        <div class="remodal browse-products" :data-remodal-id="modalID">
            <div class="modal">
                <object :data="result.submittalFile" type="application/pdf" width="100%" height="500px"  v-if="active">
                    <p class="meta coach">This browser does not support inline PDFs. Please download the PDF to view it. <a :href="`${result.submittalFile}?&download=1`">Download PDF</a></p>
                </object>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex';
    import Modal from 'vue/common/_modal';
    import _ from 'lodash';

    export default {
        methods: {
            selectProduct(e) {
                if (e.target.checked) {
                    this.addProduct({
                        objectID: this.result.objectID,
                        title: this.result.title,
                        submittalFile: this.result.submittalFile
                    });

                    return;
                }

                this.removeProduct(this.modalID);

            },
            ...mapMutations('mechanical', [
                'addProduct',
                'removeProduct',
            ])
        },
        computed: {
            isSelected() {
                let selected = false;

                _.each(this.$store.state.mechanical.temporaryProducts, product => {
                    if(product.objectID == this.modalID){
                        selected = true;
                    }
                });

                return selected;
            }
        },
        extends: Modal,
        props: ['submittalID']
    }
</script>